  export function formatToEst(dateString?: string | null) {
            if (!dateString) return "-";
          
            // If the string ends with 'Z', treat it as UTC
            const isUtc = dateString.endsWith("Z");
            const date = new Date(dateString);
          
            if (isUtc) {
              // Convert UTC to EST
              return date.toLocaleString("en-US", { timeZone: "America/New_York" });
            } else {
              // Assume it’s already in local time
              return date.toLocaleString(); // or just return dateString
            }
          }